import { on } from '@ember/modifier';

import onHoverPopup from 'webapp/modifiers/on-hover-popup';
import type { Args as BaseArgs } from 'webapp/components/data-status-base';
import DataStatusBaseComponent from 'webapp/components/data-status-base';

export interface Args extends BaseArgs {
	text: string;
}

export default class DataStatusTextComponent<T extends Args> extends DataStatusBaseComponent<T> {
	offset = 8;
	<template>
		<div class="data-status-text">
			{{#if this.navigationService.isMobileApp}}
				<span role="button" {{on "click" this.clickAction}}>{{@text}}</span>
			{{else}}
				<span {{onHoverPopup this.openPopup}}>{{@text}}</span>
			{{/if}}
		</div>
	</template>
}
